import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import store from "../store/index";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  rtl: true,
  theme: {
    dark: store.state.darkMode,
    customProperties: true,
    themes: {
      light: {
        primary: "#ff7900",
        secondary: "#000",
        accent: "#8c9eff",
        grayText: "#717171",
        lightSuccess: "#dbf4cd",
        lightError: "#fed9bf",
        lightBlue:"#cbfef9",
      },
      dark: {
        primary: "#55c0b4",
        black: "#fff",
        success: "#55c0b4",
        secondary: "#0c1939",
      },
    },
  },
});
